// JavaScript Multi Language (JSML)
export function jsml($language, $term) {
  let data = "";

  const storedTerms = [
    {
      term: "View Room",
      lang: {
        en: "View Room",
        vi: "Xem phòng",
        "zh-hans": "观景房",
        "zh-hant": "查看房間",
      },
    },
    {
      term: "Book Now",
      lang: {
        en: "Book Now",
        vi: "Đặt ngay",
        "zh-hans": "预订",
        "zh-hant": "預訂",
      },
    },
    {
      term: "Offer",
      lang: {
        en: "Offer",
        vi: "Ưu đãi",
        "zh-hans": "优惠",
        "zh-hant": "優惠",
      },
    },
    {
      term: "View Offer",
      lang: {
        en: "View Offer",
        vi: "Xem ưu đãi",
        "zh-hans": "查看优惠",
        "zh-hant": "查看優惠",
      },
    },
    {
      term: "From (USD)",
      lang: {
        en: "From (USD)",
        vi: "từ (Đô Mỹ)",
        "zh-hans": "从(美元)",
        "zh-hant": "從(美元)",
      },
    },
    {
      term: "Size",
      lang: {
        en: "Size",
        vi: "Kích thước",
        "zh-hans": "尺寸",
        "zh-hant": "尺寸",
      },
    },
    {
      term: "Guests",
      lang: {
        en: "Guests",
        vi: "Khách",
        "zh-hans": "客人",
        "zh-hant": "客人",
      },
    },
    {
      term: "Capacity",
      lang: {
        en: "Capacity",
        vi: "Sức chứa",
        "zh-hans": "容量",
        "zh-hant": "容量",
      },
    },
    {
      term: "View Space",
      lang: {
        en: "View Space",
        vi: "Xem không gian",
        "zh-hans": "查看空间",
        "zh-hant": "查看空間",
      },
    },
    {
      term: "There are no current packages & promotions.",
      lang: {
        en: "There are no current packages & promotions.",
        vi: "Hiện tại chưa có chương trình ưu đãi mới nhất",
        "zh-hans": "目前没有优惠或促销活动",
        "zh-hant": "目前沒有優惠或促銷活動",
      },
    },
    {
      term: "There are no current events at The Reverie Saigon.",
      lang: {
        en: "There are no current events at The Reverie Saigon.",
        vi: "Hiện tại không có sự kiện diễn ra tại khách sạn The Reverie Saigon",
        "zh-hans": "西贡万韵酒店暂无活动",
        "zh-hant": "西貢萬韻酒店暫無活動",
      },
    },
    {
      term: "View Gallery",
      lang: {
        en: "View Gallery",
        vi: "Xem thư viện",
        "zh-hans": "查看相册",
        "zh-hant": "查看相冊",
      },
    },
    {
      term: "Video Gallery",
      lang: {
        en: "Video Gallery",
        vi: "Thư viện video",
        "zh-hans": "视频相册",
        "zh-hant": "視頻相冊",
      },
    },
    {
      term: "View Video",
      lang: {
        en: "View Video",
        vi: "Xem video",
        "zh-hans": "观看视频",
        "zh-hant": "觀看視頻",
      },
    },
    {
      term: "Photo Gallery",
      lang: {
        en: "Photo Gallery",
        vi: "Thư viện ảnh",
        "zh-hans": "相册",
        "zh-hant": "相冊",
      },
    },
    {
      term: "Suites",
      lang: {
        en: "Suites",
        vi: "Suites",
        "zh-hans": "套房",
        "zh-hant": "套房",
      },
    },
  ];

  function filterIt(array, value, key) {
    return array.filter(
      key
        ? (a) => a[key] === value
        : (a) => Object.keys(a).some((k) => a[k] === value)
    )[0];
  }

  if (!filterIt(storedTerms, $term)) {
    return "[term not found: " + $term + "]";
  }

  if (!filterIt(storedTerms, $term).lang[$language]) {
    return `[ ${$language} term not found ]`;
  }

  return filterIt(storedTerms, $term).lang[$language];
}
